import { GET } from "../../API/get";

export const fetchFtmRatings = async (ftm_id, page_number, sort_by_rating, filter_by_rating) => {
    const response = await GET(`job/customer/reviews-and-ratings/${ftm_id}/${page_number}?sort_by_rating=${sort_by_rating}&filter_by_rating=${filter_by_rating}`);
    return response?.status === "Success" ? response : null;
}